// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IIRtlyC73sODQ9eQpyDL,
.cIyVMaa9r4j0qmrxiVld,
.RCFvyiyMxenqUr1j1sej {
    margin: 0;
    padding: 1rem;
    border-radius: 0.5rem;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 1rem;
}

.IIRtlyC73sODQ9eQpyDL {
    border: 1px solid #526AF2;
    background-color: rgba(82, 106, 242, 0.1);
}

.IIRtlyC73sODQ9eQpyDL span,
.cIyVMaa9r4j0qmrxiVld span,
.RCFvyiyMxenqUr1j1sej span {
    color: #565656;
    font-size: 1rem;
}

.IIRtlyC73sODQ9eQpyDL .QW9v3jzNRzw8TI0qruaq {
    color: #526AF2;
}

.cIyVMaa9r4j0qmrxiVld {
    border: 1px solid #FF4D4F;
    background-color: rgba(255, 77, 79, 0.1);
}

.cIyVMaa9r4j0qmrxiVld .QW9v3jzNRzw8TI0qruaq {
    color: #FF4D4F;
}

.RCFvyiyMxenqUr1j1sej {
    border: 1px solid #52C41A;
    background-color: rgba(82, 196, 26, 0.1);
}

.RCFvyiyMxenqUr1j1sej .QW9v3jzNRzw8TI0qruaq {
    color: #52C41A;
}

.JEVcI_orQL59yRNB18K4 {
    border: 1px solid lightgrey;
    border-radius: 0.5rem;
    padding: 0.5rem 1rem;
    background-color: white;
    color: #565656;
    font-size: 1rem;
    cursor: pointer;
    box-shadow: 1px 2px 2px lightgrey;
    transition: 0.3s;
}

.JEVcI_orQL59yRNB18K4:hover {
    background-color: #eeeeee;
    box-shadow: none;
}

.JEVcI_orQL59yRNB18K4:disabled {
    opacity: 0.5;
    box-shadow: none;
}

.JEVcI_orQL59yRNB18K4:disabled:hover {
    background-color: white;
}

.yhymasLBk_lrtMcJixpA {
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
}

.tRSxPILdf1MWHByC1coS {
    position: fixed;
    top: 0;
    right: 0;
    background: rgba(255, 255, 255, 0.7);
    -webkit-backdrop-filter: blur(5px);
    backdrop-filter: blur(5px);
    overflow: hidden;
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
}

.YWlMwe3PA0XxHWK_Wj97 {
    padding: 2rem;
    background-color: white;
    border-radius: 0.5rem;
    animation-delay: 0.3s;
    box-shadow: 0 1px 53px -5px rgba(0, 0, 0, 0.13);
    max-width: 500px;
}

.xxgxpFG3Z5kk9_H_01Tf {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    gap: 1rem;
}

.JEVcI_orQL59yRNB18K4.DxasHnvADojCc6bQ8WjC {
    background-color: #FF4D4F;
    border-color: #FF4D4F;
    color: white;
}

.JEVcI_orQL59yRNB18K4.DxasHnvADojCc6bQ8WjC:hover {
    background-color: #cc3d3d;
    border-color: #cc3d3d;
}

.zzL4piVK64DoLY4bYFOV {
    font-size: 1.15rem;
    font-weight: 500;
    margin-top: 0;
    margin-bottom: 0.75rem;
}

.H0UqfamguCy6RD8aBHjE {
    color: #565656;
    margin-bottom: 1.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/RefundRequest/RefundRequest.module.css"],"names":[],"mappings":"AAAA;;;IAGI,SAAS;IACT,aAAa;IACb,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;;;IAGI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,wCAAwC;AAC5C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,wCAAwC;AAC5C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,qBAAqB;IACrB,oBAAoB;IACpB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,eAAe;IACf,iCAAiC;IACjC,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,oCAAoC;IACpC,kCAAkC;IAClC,0BAA0B;IAC1B,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,qBAAqB;IACrB,+CAA+C;IAC/C,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB","sourcesContent":[".info,\n.rejected,\n.validated {\n    margin: 0;\n    padding: 1rem;\n    border-radius: 0.5rem;\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    gap: 1rem;\n}\n\n.info {\n    border: 1px solid #526AF2;\n    background-color: rgba(82, 106, 242, 0.1);\n}\n\n.info span,\n.rejected span,\n.validated span {\n    color: #565656;\n    font-size: 1rem;\n}\n\n.info .icon {\n    color: #526AF2;\n}\n\n.rejected {\n    border: 1px solid #FF4D4F;\n    background-color: rgba(255, 77, 79, 0.1);\n}\n\n.rejected .icon {\n    color: #FF4D4F;\n}\n\n.validated {\n    border: 1px solid #52C41A;\n    background-color: rgba(82, 196, 26, 0.1);\n}\n\n.validated .icon {\n    color: #52C41A;\n}\n\n.button {\n    border: 1px solid lightgrey;\n    border-radius: 0.5rem;\n    padding: 0.5rem 1rem;\n    background-color: white;\n    color: #565656;\n    font-size: 1rem;\n    cursor: pointer;\n    box-shadow: 1px 2px 2px lightgrey;\n    transition: 0.3s;\n}\n\n.button:hover {\n    background-color: #eeeeee;\n    box-shadow: none;\n}\n\n.button:disabled {\n    opacity: 0.5;\n    box-shadow: none;\n}\n\n.button:disabled:hover {\n    background-color: white;\n}\n\n.loader {\n    display: flex;\n    flex-direction: row;\n    gap: 0.5rem;\n}\n\n.background {\n    position: fixed;\n    top: 0;\n    right: 0;\n    background: rgba(255, 255, 255, 0.7);\n    -webkit-backdrop-filter: blur(5px);\n    backdrop-filter: blur(5px);\n    overflow: hidden;\n    width: 100%;\n    height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.modal {\n    padding: 2rem;\n    background-color: white;\n    border-radius: 0.5rem;\n    animation-delay: 0.3s;\n    box-shadow: 0 1px 53px -5px rgba(0, 0, 0, 0.13);\n    max-width: 500px;\n}\n\n.button-group {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 1rem;\n}\n\n.button.danger {\n    background-color: #FF4D4F;\n    border-color: #FF4D4F;\n    color: white;\n}\n\n.button.danger:hover {\n    background-color: #cc3d3d;\n    border-color: #cc3d3d;\n}\n\n.title {\n    font-size: 1.15rem;\n    font-weight: 500;\n    margin-top: 0;\n    margin-bottom: 0.75rem;\n}\n\n.description {\n    color: #565656;\n    margin-bottom: 1.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"info": `IIRtlyC73sODQ9eQpyDL`,
	"rejected": `cIyVMaa9r4j0qmrxiVld`,
	"validated": `RCFvyiyMxenqUr1j1sej`,
	"icon": `QW9v3jzNRzw8TI0qruaq`,
	"button": `JEVcI_orQL59yRNB18K4`,
	"loader": `yhymasLBk_lrtMcJixpA`,
	"background": `tRSxPILdf1MWHByC1coS`,
	"modal": `YWlMwe3PA0XxHWK_Wj97`,
	"button-group": `xxgxpFG3Z5kk9_H_01Tf`,
	"danger": `DxasHnvADojCc6bQ8WjC`,
	"title": `zzL4piVK64DoLY4bYFOV`,
	"description": `H0UqfamguCy6RD8aBHjE`
};
export default ___CSS_LOADER_EXPORT___;
